import React from 'react';
import PropTypes from 'prop-types';
import './_tiptap.toolbar.scss'
import './_tiptap.toolbar.dark-mode.scss'
import classNames from 'classnames';
import ToolbarButton from './Button';
import { getTooltip } from './helpers';

const Toolbar = ({ editor, toolbar, position }) => {
  if (!editor || !toolbar.length) {
    return null
  }

  return (
    <div className={classNames('tiptap-toolbar', {
      'tiptap-toolbar__top': position === 'top',
      'tiptap-toolbar__bottom': position === 'bottom',
    })}
    >
      <div className="tiptap-toolbar__list">
        {toolbar.map((group, index) => (
          <div
            key={`tiptap-toolbar-group-${index}`}
            className="tiptap-toolbar__group"
          >
            {group.map((item, index) => {
              const tooltip = getTooltip(item);
              switch (item) {
              case 'bold':
                return (
                  <ToolbarButton
                    key={`toolbar-button-${index}`}
                    tooltip={tooltip}
                    active={editor.isActive('bold')}
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    icon="fas fa-bold"
                  />
                )
              case 'italic':
                return (
                  <ToolbarButton
                    tooltip={tooltip}
                    key={`toolbar-button-${index}`}
                    active={editor.isActive('italic')}
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    icon="fas fa-italic"
                  />
                )
              case 'blockquote':
                return (
                  <ToolbarButton
                    tooltip={tooltip}
                    key={`toolbar-button-${index}`}
                    active={editor.isActive('blockquote')}
                    onClick={() => editor.chain().focus().toggleBlockquote().run()}
                    icon="fas fa-quote-right"
                  />
                )
              case 'ul':
                return (
                  <ToolbarButton
                    tooltip={tooltip}
                    key={`toolbar-button-${index}`}
                    active={editor.isActive('bulletList')}
                    onClick={() => editor.chain().focus().toggleBulletList().run()}
                    icon="far fa-list"
                  />
                )
              case 'ol':
                return (
                  <ToolbarButton
                    tooltip={tooltip}
                    key={`toolbar-button-${index}`}
                    active={editor.isActive('orderedList')}
                    onClick={() => editor.chain().focus().toggleOrderedList().run()}
                    icon="fas fa-list-ol"
                  />
                )
              case 'hr':
                return (
                  <ToolbarButton
                    tooltip={tooltip}
                    key={`toolbar-button-${index}`}
                    onClick={() => editor.chain().focus().setHorizontalRule().run()}
                    icon="fas fa-divide"
                  />
                )
              default:
                return null;
              }
            })}
          </div>
        ))}
      </div>

    </div>
  )
}

Toolbar.defaultProps = {
  toolbar: [],
}

Toolbar.propTypes = {
  editor: PropTypes.any,
  toolbar: PropTypes.array,
  position: PropTypes.bool,
};

export default Toolbar;
